module.exports = __webpack_public_path__ + "static/media/404-piggy-is-here-for-you.330054c8.jpg";